module.exports = __webpack_public_path__ + "img/202510_05.b46a1a72.png";